import { createSlice } from "@reduxjs/toolkit";
import { fetchWallets, fetchWalletsById } from "./wallets.fetch";

const initialState = {
  wallets: null,
  currentWallet: null,
  isLoading: false,
  isError: null,
};

const waletsReducers = createSlice({
  name: "waletsReducer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchWallets.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.wallets = payload;
    });

    builder.addCase(fetchWallets.pending, (state) => {
      state.isLoading = true;
      state.isError = null;
    });

    builder.addCase(fetchWallets.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.isError = payload;
    });

    builder.addCase(fetchWalletsById.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(fetchWalletsById.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.currentWallet = payload;
    });

    builder.addCase(fetchWalletsById.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.isError = payload;
    });
  },
});

export const walletsReduser = waletsReducers.reducer;
